/**
 * Extract a user-friendly error message from various error formats
 * Handles: strings, Pydantic validation errors (arrays), objects with msg property
 */
export const getErrorMessage = (error, fallback = 'An error occurred') => {
  const detail = error.response?.data?.detail;
  
  // If detail is a string, return it directly
  if (typeof detail === 'string') {
    return detail;
  }
  
  // If detail is an array (Pydantic validation errors), extract messages
  if (Array.isArray(detail)) {
    const messages = detail.map(err => {
      if (typeof err === 'string') return err;
      if (err.msg) return err.msg;
      if (err.message) return err.message;
      return JSON.stringify(err);
    });
    return messages.join(', ');
  }
  
  // If detail is an object with msg property (single validation error)
  if (detail && typeof detail === 'object') {
    if (detail.msg) return detail.msg;
    if (detail.message) return detail.message;
  }
  
  // Fallback to error message or default
  return error.message || fallback;
};
